export interface Project {
  id: number;
  title: string;
  description: string;
  image?: string;
  github: string;
  demo?: string;
  tags: string[];
}

export const projects: Project[] = [
  {
    id: 1,
    title: "RAG AI-бот на Make",
    description: "Телеграм-бот c RAG AI, работает в текстовом и голосовом режимах, интеграция с векторной базой Weaviate и Юкассой",
    image: "/images/ihs.png",
    github: "",
    demo: "",
    tags: ["MAKE.COM", "API", "OpenAI", "RAG", "Weaviate"]
  },

   {
    id: 2,
    title: "N8N Crossposting",
    description: "Кросспостинг из Telegram-канала в ВК и Threads ",
    image: "/images/n8n_crosspost.png",
    github: "",
    demo: "",
    tags: ["N8N", "JavaScript", "Автоматизации"]
  },
  {
    id: 3,
    title: "Телеграм-бот для заказа гостевых пропусков в ЖК",
    description: "Интеграция с Bitrix, распознавание голосовых сообщений",
    image: "/images/bitrix_pass.png",
    github: "https://github.com/dichenko/bitrix_acess",
    demo: "",
    tags: ["API", "Bitrix", "TypeScript", "YandexSpeech"]
  },
    {
    id: 4,
    title: "LMS - система управления обучением",
    description: "Телеграм-бот для студентов + админка для преподавателей ",
    image: "/images/smjlms.png",
    github: "https://github.com/dichenko/smj_lms",
    demo: "https://t.me/smj_lms_bot",
    tags: ["React", "TypeScript", "Telegram-bot", "WebApp"]
  },
    {
    id: 5,
    title: "Скрипт для Photoshop",
    description: "Face Placement Helper экономит часы рутинной работы при подготовке групповых портретов (выпускные альбомы детсад/школа/ВУЗ). ",
    image: "/images/photoscript.png",
    github: "https://github.com/dichenko/photoshop-face-placement-helper",
    demo: "",
    tags: ["Python", "JavaScript", "Photoshop", "OpenCV"]
  },
    {
    id: 6,
    title: "SMJ Vote",
    description: "Mini-app для голосования на конкурсе с защитой от накруток",
    image: "/images/smjvote.png",
    github: "https://github.com/dichenko/smj_vote",
    demo: "https://t.me/smj_vote_bot?startapp",
    tags: ["Telegram Mini-App", "Next.js", "TypeScript", "React"]
  },
   {
    id: 7,
    title: "TG user parsing CLI",
    description: "CLI-утилита для парсинга списка пользователей из закрытых чатов Telegram",
    image: "/images/tgscrap.png",
    github: "https://github.com/dichenko/TG_UserScrap_cli",
    demo: "",
    tags: ["Python", "CLI"]
  },
    {
    id: 8,
    title: "SMJ Blitz Game",
    description: "Интерактивная игра для быстрого проведения квизов и викторин в группах",
    image: "/images/smjblitz.png",
    github: "https://github.com/dichenko/smj-blitz-game",
    demo: "https://smj-blitz-game.vercel.app/",
    tags: ["Next.js", "React", "Tailwind "]
  },

  {
    id: 9,
    title: "FeelMe36",
    description: "Телеграм Mini App для влюблённых пар. Помогает глубже узнать ценности друг друга",
    image: "/images/feelme.png",
    github: "https://github.com/dichenko/Feel36/",
    demo: "https://t.me/feelme36_bot?startapp",
    tags: ["Telegram Mini-App", "React", "TypeScript", "Vite", "Tailwind"]
        
  },

  {
    id: 10,
    title: "Электронный дневник для образовательного проекта",
    description: "Электронный дневник для образовательного проекта. Отслеживание занятий в 15 филиалах, отчеты для методистов",
    image: "/images/smjparse.png",
    github: "https://github.com/dichenko/smj-parse",
    demo: "",
    tags: ["Python", "Flask", "Bootstrap"]
  },
  {
    id: 11,
    title: "Bobr Calendar Widget",
    description: "Виджет для Windows, показывает время до окончания встречи из Google-календаря",
    image: "/images/bobr-calendar.png",
    github: "https://github.com/dichenko/Bobr-Calendar-Widget",
    demo: "",
    tags: ["Electron.js", "Node.js", "Windows"]
  },
  {
    id: 12,
    title: "Smart Contract Portfolio",
    description: "Коллекция смарт-контрактов на Solidity",
    image: "",
    github: "https://github.com/dichenko/Smart_contract_portfolio",
    demo: "",
    tags: ["Solidity", "Smart Contract", "Blockchain"]
  },
  {
    id: 13,
    title: "ERC20 Bebych",
    description: "Пример смарт-контракта токена стандарта ERC-20 на Solidity",
    image: "",
    github: "https://github.com/dichenko/ERC20Bebych",
    demo: "",
    tags: ["Solidity", "ERC-20", "Smart Contract", "Blockchain", "Ethereum"]
  },
  {
    id: 14,
    title: "Staking Contract",
    description: "Смарт-контракт для организации системы стейкинга на блокчейне",
    image: "",
    github: "https://github.com/dichenko/StakingContract",
    demo: "",
    tags: ["Solidity", "Blockchain", "Ethereum"]
  },
  {
    id: 15,
    title: "Crypton Votings",
    description: "Система децентрализованного голосования на смарт-контрактах Ethereum",
    image: "",
    github: "https://github.com/dichenko/Crypton_Votings",
    demo: "",
    tags: ["Solidity", "Smart Contract", "Blockchain", "Ethereum"]
  }

]; 